import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
// import CardList from '../card/CardList';
// import ScheduleList from '../schedule/ScheduleList';
// import CourseDefinitionList from '../card/CourseDefinitionList';
// import ClassroomList from './ClassroomList';
// import TeachClassList from './TeachClassList';
import TeacherDataList from './TeacherDataList';
import FinanceDataList from './FinanceDataList';
import WechatLogList from '../account/WechatLogList';
import WechatNoticeLogList from '../account/WechatNoticeLogList';

const { TabPane } = Tabs;


const ScheduleView = (props: any) => {

  const [currentTabKey, setCurrentTabKey] = useState<number>(1);
  const [kxVisible, setKxVisible] = useState(false);
  const [cwVisible, setCwVisible] = useState(false);
  const [wechatlogVisible, setWechatlogVisible] = useState(false);
  const [wechatNoticelogVisible, setWechatNoticelogVisible] = useState(false);

  function getUrlParam(name: string, str: string) {
    const paramUrl = str.split('?');
    if (paramUrl.length == 1) {
      return null;
    }
    const params = paramUrl[1].split('&');
    for (var i = 0; i < params.length; i++) {
      const value = params[i].split('=');
      if (value[0] == name) {
        return value[1];
      }
    }
    return null;
  }

  const tabExtraContent = () => {
    switch (currentTabKey) {
      // case 2:
      //   return <Button type="primary" onClick={() => {
      //     setTeachClassVisible(true);
      //   }} icon={<PlusOutlined />}>
      //     新增班级
      //   </Button>
      // case 3:
      //   return <Button type="primary" onClick={() => {
      //     setClassroomVisible(true);
      //   }} icon={<PlusOutlined />}>
      //     新增教室
      //   </Button>
      case 1:
      default:
        return <></>
    }
  }

  function onTabChange(key: any) {
    console.log(key);
    setCurrentTabKey(Number(key));
  }

  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={['数据大盘']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Tabs defaultActiveKey={getUrlParam('index', window.location.href)!} onChange={onTabChange} style={{ marginBottom: 32 }}
              tabBarExtraContent={tabExtraContent()}>
              <TabPane tab="课消数据" key="1">
                <TeacherDataList
                  visible={kxVisible}
                  setVisible={setKxVisible}
                />
              </TabPane>
              <TabPane tab="财务数据" key="2">
                <FinanceDataList
                  visible={cwVisible}
                  setVisible={setCwVisible}
                />
              </TabPane>
              <TabPane tab="微信操作日志" key="3">
                <WechatLogList
                  visible={wechatlogVisible}
                  setVisible={setWechatlogVisible}
                />
              </TabPane>
              <TabPane tab="微信通知日志" key="7">
                <WechatNoticeLogList
                  visible={wechatNoticelogVisible}
                  setVisible={setWechatNoticelogVisible}
                />
              </TabPane>
            </Tabs>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ScheduleView;
